const AUTH_STORAGE_KEY = "nccia_auth";

const safeParse = (value) => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

export const getStoredAuth = () => {
  if (typeof window === "undefined") return null;
  return safeParse(window.localStorage.getItem(AUTH_STORAGE_KEY));
};

export const setStoredAuth = (auth) => {
  if (typeof window === "undefined") return;
  if (!auth) {
    window.localStorage.removeItem(AUTH_STORAGE_KEY);
    return;
  }
  window.localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(auth));
};

export const clearStoredAuth = () => {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(AUTH_STORAGE_KEY);
};

const nativeFetch =
  typeof window !== "undefined" && window.fetch
    ? window.fetch.bind(window)
    : (...args) => fetch(...args);

export const apiFetch = async (input, init = {}) => {
  const auth = getStoredAuth();
  const headers = new Headers(init.headers || {});
  if (auth?.token && !headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${auth.token}`);
  }
  const response = await nativeFetch(input, {
    ...init,
    headers,
  });
  if (typeof window !== "undefined" && response.status === 401) {
    window.dispatchEvent(new Event("auth:logout"));
  }
  return response;
};

export const attachAuthFetch = () => {
  if (typeof window === "undefined") return;
  if (window.__authFetchAttached) return;
  window.fetch = apiFetch;
  window.__authFetchAttached = true;
};

export { AUTH_STORAGE_KEY };
